import {Button} from '@hm/fundamental'
import {mdiPrinterOutline} from '@mdi/js'
import {Suspense, useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useReactToPrint} from 'react-to-print'

import {StaticPartShutdownPrintContent} from './StaticPartShutdownPrintContent'

import {StaticPartComponentDto} from '@refra/modules/refra-static-parts/types'

interface StaticPartShutdownPrintButtonProps {
  selectedComponent: StaticPartComponentDto
}

export const StaticPartShutdownPrintButton = ({
  selectedComponent
}: StaticPartShutdownPrintButtonProps) => {
  const {t} = useTranslation()
  const printRef = useRef<HTMLDivElement>(null)
  const [shouldRenderPrintContent, setShouldRenderPrintContent] = useState(false)

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: t('staticParts.report.title'),
    onAfterPrint: () => {
      setShouldRenderPrintContent(false)
    },
    pageStyle: `
    @page {
      size: landscape;
    }

    @media print {
      body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
    }
  `
  })

  return (
    <>
      {shouldRenderPrintContent && (
        <div style={{position: 'absolute', left: '-9999px', top: 0, width: '100%', height: '100%'}}>
          <Suspense fallback={null}>
            <StaticPartShutdownPrintContent
              ref={printRef}
              selectedComponent={selectedComponent}
              onReady={() => handlePrint()}
            />
          </Suspense>
        </div>
      )}
      <Button
        icon={mdiPrinterOutline}
        variant="tertiary"
        onClick={() => setShouldRenderPrintContent(true)}
        data-cy="static_part_shutdown_print_button"
      >
        {t('common.print')}
      </Button>
    </>
  )
}
